import axios from 'axios';
import apiConfig from 'apiConfig';
import api from '@/api';
import { Notification } from 'element-ui';

const path = (url, isMock) => {
  return isMock === true ? `http://localhost:3000/${url}` : `${apiConfig.apiUrl}/${url}`;
};

const errorCodesLogOut = [401,403];

const onError = function(error) {
  if(error && error.message){
    let code = error.message.match(/([0-9]{3})/)
    let shouldLogOut = errorCodesLogOut.includes(parseInt(code))
    let errorMessage = error.response && error.response.data && error.response.data.conflicts && error.response.data.conflicts.map((e) => {
      return e.message}
    ).join("\n");
  
    Notification.error({
      title: `${error.name}`,
      message: `${errorMessage ? errorMessage : error.message}`,
      duration: 5000,
      onClose: function() {
        if(shouldLogOut) {
          api.auth.logout();
          location.reload();
        }
      }
    });
  }
}

/**
 * @TODO - Several chunks of repeated code, can be greatly simplified with a proxy.
 */
export default {
  get: async function get(url, isMock) {
    try {
      const userSession = await api.auth.getUserSession();

      if (userSession) {
        const res = await axios.get(path(url, isMock), {
          headers: { Authorization: `Bearer ${userSession.idToken.jwtToken}` }
        });
  
        return res ? res.data : null;
      }
    } catch (error) {
      onError(error)
    }
  },

  post: async function post(url, params, isMock) {
    try {
      const userSession = await api.auth.getUserSession();

      if (userSession) {
        const data = await axios.post(path(url, isMock), params, {
          headers: {
            Authorization: `Bearer ${userSession.idToken.jwtToken}`,
            'Access-Control-Allow-Origin': '*'
          }
        }).catch((error) => onError(error));
        return data && data.data;
      }
    } catch (error) {
      onError(error)
    }
  },

  put: async function put(url, params, isMock) {
    try {
      const userSession = await api.auth.getUserSession();

      if (userSession) {
        const { data } = await axios.put(path(url, isMock), params, {
          headers: { Authorization: `Bearer ${userSession.idToken.jwtToken}` }
        });

        return data;
      }
    } catch (error) {
      onError(error)
    }
  },

  delete: async function del(url, params, isMock) {
    try {
      const userSession = await api.auth.getUserSession();

      if (userSession) {
        const { data } = await axios.delete(path(url, isMock), {
          headers: { Authorization: `Bearer ${userSession.idToken.jwtToken}` },
          data: params
        });

        return data;
      }
    } catch (error) {
      onError(error)
    }
  },

  search: function search(label) {
    return this.get(`search?record.label_like=${label}`, true);
  },

  getSensor: function getSensor(id) {
    return this.get(`sensors/${id}`);
  },

  getUser: function getUser(userId) {
    return this.get(`users/${userId}`);
  },

  getUserPermissions: function getUserPermissions(userId) {
    return this.get(`users/${userId}/permissions`);
  },

  getUserReports: function getUserReports(userId) {
    return this.get(`users/${userId}/reports`);
  },

  updateUser: function updateUser(userId, params) {
    return this.put(`users/${userId}`, params);
  },

  updateOrg: function updateOrg(orgId, params) {
    return this.put(`organisations/${orgId}`, params);
  },

  updateOrgParts: function updateOrgParts(id, params) {
    return this.put(`organisations/${id}/parts`, params);
  },

  updateFarm: function updateFarm(farmId, params) {
    return this.put(`farms/${farmId}`, params);
  },

  updateGroup: function updateGroup(groupId, params) {
    return this.put(`orchards/${groupId}`, params);
  },

  updateGroupSensors: function updateGroupSensors(groupId, params) {
    return this.put(`orchards/${groupId}/sensors`, params);
  },

  addSensorsToGroup: function addSensorsToGroup(groupId, params) {
    return this.post(`orchards/${groupId}/sensors`, params);
  },

  createSensorStatus: function createSensorStatus(sensorId, params) {
    return this.post(`sensors/${sensorId}/status`, params);
  },

  removeSensorsFromGroup: function removeSensorsFromGroup(groupId, params) {
    return this.delete(`orchards/${groupId}/sensors`, params);
  },

  updateSensor: function updateSensor(sensorId, params) {
    return this.put(`sensors/${sensorId}`, params);
  },

  getLures: function getLures() {
    return this.get(`lures`);
  },

  getOrg: function getOrg(id) {
    return this.get(`organisations/${id}`);
  },

  getOrgBatteries: function getOrgBatteries(id) {
    return this.get(`organisations/${id}/parts/battery`);
  },

  getOrgFarms: function getOrgFarms(id) {
    return this.get(`organisations/${id}/farms`);
  },

  getOrgParts: function getOrgParts(id) {
    return this.get(`organisations/${id}/parts`);
  },

  getOrgUsers: function getOrgUsers(id) {
    return this.get(`organisations/${id}/users`);
  },

  getOrgSensors: function getOrgSensors(id) {
    return this.get(`organisations/${id}/sensors`);
  },

  getFarm: function getFarm(id) {
    return this.get(`farms/${id}`);
  },

  getFarmGroups: function getFarmGroups(id) {
    return this.get(`farms/${id}/orchards`);
  },

  getGroup: function getGroup(id) {
    return this.get(`orchards/${id}`);
  },

  getGroupSensors: function getGroupSensors(id) {
    return this.get(`orchards/${id}/sensors?limit=300`);
  },

  getGroupUsers: function getGroupUsers(id) {
    return this.get(`orchards/${id}/users?limit=300`);
  },

  getGroupDetections: function getGroupDetections(id, params) {
    params = params
      ? `?${Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')}`
      : '';
    return this.get(`orchards/${id}/detections${params}`);
  },

  getUsers: function getUsers(params) {
    // params = params ? `?${new URLSearchParams(params).toString()}` : ''
    params = params
      ? `?${Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')}`
      : '';

    return this.get(`users${params}`);
  },

  getOrgs: function getOrgs(params) {
    // params = params ? `?${new URLSearchParams(params).toString()}` : ''
    params = params
      ? `?${Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')}`
      : ''; // TODO DRY

    return this.get(`organisations${params}`);
  },

  getPestTypes: function getPestTypes() {
    return this.get(`getPestTypes`);
  },

  getFarms: function getFarms(params) {
    // params = params ? `?${new URLSearchParams(params).toString()}` : ''
    params = params
      ? `?${Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')}`
      : ''; // TODO DRY

    return this.get(`farms${params}`);
  },

  getGroups: function getGroups(params) {
    // params = params ? `?${new URLSearchParams(params).toString()}` : ''
    params = params
      ? `?${Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')}`
      : ''; // TODO DRY

    return this.get(`orchards${params}`);
  },

  getSensors: function getSensors(params) {
    // params = params ? `?${new URLSearchParams(params).toString()}` : ''
    params = params
      ? `?${Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')}`
      : ''; // TODO DRY

    return this.get(`sensors${params}`);
  },

  getSensorDetections: function getSensorDetections(params) {
    // TODO add sensor ID
    params = params ? `?${new URLSearchParams(params).toString()}` : '';
    return this.get(`detections${params}`, true);
  },

  getSensorOrganisations: function getSensorOrganisations(id) {
    return this.get(`sensors/${id}/organisations`);
  },

  linkSensorOrganisation: function linkSensorOrganisation(id, params) {
    return this.post(`sensors/${id}/organisations`, params);
  },

  removeSensorOrganisation: function removeSensorOrganisation(id, params) {
    return this.delete(`sensors/${id}/organisations`, params);
  },

  getSensorSuggestedOrganisations: function getSensorSuggestedOrganisations(id) {
    return this.get(`sensors/${id}/suggestedOrganisations`);
  },

  getSensorStatusAll: function getSensorStatusAll() {
    return this.get(`status/sensors`);
  },

  getReports: function getReports(params) {
    // params = params ? `?${new URLSearchParams(params).toString()}` : ''
    params = params
      ? `?${Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')}`
      : '';

    return this.get(`reports${params}`);
  },

  getReport: function getReport(id) {
    return this.get(`reports/${id}`);
  },

  getReportGroups: function getReportGroups(id) {
    return this.get(`reports/${id}/groups`);
  },

  getReportRecipients: function getReportRecipients(id) {
    return this.get(`reports/${id}/recipients`);
  },

  getReportLogs: function getReportLogs(id) {
    return this.get(`reports/${id}/logs`);
  },

  createReport: function createReport(params) {
    return this.post(`reports`, params);
  },

  addReportGroups: function addReportGroups(id, params) {
    return this.post(`reports/${id}/groups`, params);
  },

  removeReportGroups: function removeReportGroups(id, params) {
    return this.delete(`reports/${id}/groups`, params);
  },

  addReportRecipients: function addReportRecipients(id, params) {
    return this.post(`reports/${id}/recipients`, params);
  },

  removeReportRecipients: function removeReportRecipients(id, params) {
    return this.delete(`reports/${id}/recipients`, params);
  },

  updateReport: function updateReport(id, params) {
    return this.put(`reports/${id}`, params);
  },

  createOrg: function createOrg(params) {
    return this.post(`organisations`, params);
  },

  createOrgBattery: function createOrgBattery(id, params) {
    return this.post(`organisations/${id}/parts/battery`, params);
  },

  // deleteOrg: async function(id) {

  //   const result = await this.delete(`orgs/${id}`, true);

  //   return result;

  // },

  // deleteFarm: async function(id) {

  //   const result = await this.delete(`farms/${id}`, true);

  //   return result;

  // },

  // deleteGroup: async function(id) {

  //   const result = await this.delete(`groups/${id}`, true);

  //   return result;

  // },

  createOrgLure: function createOrgLure(id, params) {
    return this.post(`organisations/${id}/parts`, params);
  },

  createUser: function createUser(params) {
    return this.post(`users`, params);
  },

  createFarm: function createFarm(params) {
    return this.post(`farms`, params);
  },

  createGroup: function createGroup(params) {
    return this.post(`orchards`, params);
  },

  getGridHealth: function getGridHealth(params) {
    params = params ? new URLSearchParams(params).toString() : '';
    return this.get(`gridHealth${params}`, true);
  },

  getEntitiesNames: function getEntitiesNames(params) {
    return this.post('info/name', params);
  },

  getAvailablePermissions: function getAvailablePermissions() {
    // TODO remove
    return this.get(`permissions`, true);
  },

  getRoles: function getRoles(params) {
    params = params ? `&${new URLSearchParams(params).toString()}` : '';
    return this.get(`access/roles?limit=100${params}`);
  },

  getRole: function getRole(id) {
    return this.get(`access/roles/${id}`);
  },

  createRole: function createRole(params) {
    return this.post(`access/roles`, params);
  },

  updateRole: function updateRole(id, params) {
    return this.put(`access/roles/${id}`, params);
  },

  addRolePermissions: function addRolePermissions(id, params) {
    return this.post(`access/roles/${id}/permissions`, params);
  },

  removeRolePermissions: function removeRolePermissions(id, params) {
    return this.delete(`access/roles/${id}/permissions`, params);
  },

  getPermissions: function getPermissions() {
    return this.get(`access/permissions?limit=1000`);
  },

  logoutUsers: function logoutUsers(params) {
    return this.delete(`users/sessions`, params);
  },

  addRoleToUser: function addRoleToUser(id, params) {
    return this.post(`users/${id}/permissions`, params);
  },

  removeRoleFromUser: function removeRoleFromUser(id, params) {
    return this.delete(`users/${id}/permissions`, params);
  },

  batchTrapUpdate: async function batchTrapUpdate(params) {
    return this.put(`sensors/batch`, params);
  },

  cognitoGetUser: async function cognitoGetUser(id, handleError) {
    try {
      const userSession = await api.auth.getUserSession();

      if (userSession) {
        const res = await axios.get(path(`users/${id}/cognito`), {
          headers: { Authorization: `Bearer ${userSession.idToken.jwtToken}` }
        });

        return res ? res.data : null;
      }
    } catch (error) {
      // the error needs to be handled from where it's called for this function
      // since we use the error to determine if user exists in Cognito 
      const errorMessage = error.response 
        && error.response.data 
        && error.response.data.conflicts 
        && error.response.data.conflicts[0];
      handleError(errorMessage)
    }
  },

  cognitoResetUserPassword: async function cognitoResetUserPassword(id, params) {
    return this.put(`users/${id}/cognito`, params);
  },

  cognitoDisableUser: async function cognitoDisableUser(id, params) {
    return this.put(`users/${id}/cognito/disable`, params);
  },

  cognitoEnableUser: async function cognitoEnableUser(id, params) {
    return this.put(`users/${id}/cognito/enable`, params);
  },
};
